module.exports = __webpack_public_path__ + "static/img/40007 (2).63253f6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40007 (2).webp
// module id = ogN+
// module chunks = 14